import "core-js/modules/es.object.to-string.js";
import { getUserInfo as _getUserInfo } from '@/api/auth';
/**
 * 用户相关
 * @type {{userInfo: {}}}
 */

var state = {
  userInfo: {} // 用户信息
};
var getters = {
  userInfo: function userInfo(state) {
    return state.userInfo;
  }
};
var mutations = {
  SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  }
};
var actions = {
  /**
   * 根据token获取用户信息
   * @param commit
   * @returns {Promise<unknown>}
   */
  getUserInfo: function getUserInfo(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      _getUserInfo().then(function (_ref2) {
        var data = _ref2.data;
        commit('SET_USER_INFO', data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setUserInfo: function setUserInfo(_ref3, userInfo) {
    var commit = _ref3.commit;
    commit('SET_USER_INFO', userInfo);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};